var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 25.471,
    y: 52.256,
    width: 198.892,
    height: 120.417,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeOpacity: 0,
      strokeWidth: "4.17px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.444,
    y: 35.016,
    width: 161.385,
    height: 20,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeOpacity: 0,
      strokeWidth: "4.17px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.414,
    y: 170.775,
    width: 161.385,
    height: 18.429,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeOpacity: 0,
      strokeWidth: "4.17px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.525,
    y: 187.32,
    width: 146.937,
    height: 18.429,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeOpacity: 0,
      strokeWidth: "4.17px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.875,
    y: 202.845,
    width: 11.417,
    height: 19.417,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeOpacity: 0,
      strokeWidth: "4.17px"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207.608,
    y: 172.673,
    width: 16.755,
    height: 16.532
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.649,
    y: 35.016,
    width: 16.76,
    height: 17.239
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 207.814,
    y: 35.016,
    width: 16.76,
    height: 17.239
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 83.27,
    y: 66.939,
    width: 25.044,
    height: 25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.091,
    y: 111.412,
    width: 25.044,
    height: 25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 114.31,
    y: 149.655,
    width: 25.044,
    height: 25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 141.823,
    y: 66.939,
    width: 25.044,
    height: 25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 97.026,
    y: 53.182,
    width: 57.143,
    height: 13.889
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 125.692,
    y: 91.594,
    width: 32.747,
    height: 10.79
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 125.626,
    y: 101.075,
    width: 32.823,
    height: 10.44
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 29.654,
    y: 172.751,
    width: 16.76,
    height: 16.453
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 71.538,
    y: 205.757,
    width: 16.755,
    height: 16.534
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 58.364,
    y: 222.248,
    width: 13.277,
    height: 16.428
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 46.414,
    y: 189.182,
    width: 16.755,
    height: 53.751
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 12.948,
    y: 52.256,
    width: 16.701,
    height: 120.417
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 224.363,
    y: 52.256,
    width: 16.755,
    height: 120.417
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 46.352,
    y: 18.23,
    width: 161.466,
    height: 16.791
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 88.288,
    y: 189.182,
    width: 119.466,
    height: 16.755
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.5ee61ced6d025d416fbdc1f4a74c48b9.svg";
export { ForwardRef as ReactComponent };